

let G_SHEET_URL;

const G_SHEET_SHOPIFY_SETTING = window.sizeCalculatorUrl;
if(G_SHEET_SHOPIFY_SETTING) {
    G_SHEET_URL = G_SHEET_SHOPIFY_SETTING;
} else {
    G_SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vS6a668y7GlbdUOvC-4He2pDCD2EYjDro8owAOOVU2bqAnZlnZoBW1IKs6uj82Q9KF1ngofPUaschum/pub?gid=1268245469&single=true&output=csv"
}
console.log(G_SHEET_URL, G_SHEET_SHOPIFY_SETTING)

export async function dataExport() {
    return csvToJson(await getData());
}

async function getData() {
    return await fetchGoogleSheetCSV(G_SHEET_URL);
}

let csvData = undefined;
async function fetchGoogleSheetCSV(url) {
    if (csvData) {
        return csvData;
    }

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        csvData = await response.text();
        return csvData;
    } catch (error) {
        console.error('Fetching CSV failed:', error);
        return null;
    }
}

function csvToJson(csv) {
    if(!csv) {
        return;
    }

    const lines = csv.split("\n");
    const result = [];
    const headers = lines[0].split(",");

    for (let row = 1; row < lines.length; row++) {
        const obj = {};
        const currentline = lines[row].split(",");

        for (let col = 0; col < headers.length; col++) {
            obj[headers[col]] = currentline[col];
        }
        result.push(obj);
    }

    return result;
}
